import { Component, OnInit, ElementRef, ViewChildren, QueryList, HostListener, HostBinding, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, FormArray } from '@angular/forms';
import { StepAnimations } from './step-animations';
import { FirstNameLastNameComponent } from './steps/first-name-last-name/first-name-last-name.component';
// import { LendersCountComponent } from './steps/lenders-count/lenders-count.component';
import { EmailComponent } from './steps/email/email.component';
import { PhoneComponent } from './steps/phone/phone.component';
import { FruHttpService } from '../../../../services/fru-http.service';
import { PostLead } from '../../../../shared/post-lead';
import { SelectedResponse, SelectedList, DefaultSelectedResponse, DefaultSelectedResponseUnchecked } from '../../../../shared/selected-response.model';
import { Lead } from '../../../../shared/lead';
import { StepComponent } from './step/step.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormResponse } from '../../../../shared/form-response';
import { NewHomeValueComponent } from './steps/new-home-value/new-home-value.component';
import { EstimatedDownPaymentComponent } from './steps/estimated-down-payment/estimated-down-payment.component';
import { ZipCodeComponent } from './steps/zip-code/zip-code.component';
import { FirstMortgageBalanceComponent } from './steps/first-mortgage-balance/first-mortgage-balance.component';
import { ZipCodeStreetAddressComponent } from './steps/zip-code-street-address/zip-code-street-address.component';
import { PropertyValueComponent } from './steps/property-value/property-value.component';
import { NeustarComponent } from './steps/neustar/neustar.component';
import { PropertyTypeComponent } from './steps/property-type/property-type.component';
import { PropertyUseComponent } from './steps/property-use/property-use.component';
import { BankruptcyComponent } from './steps/bankruptcy/bankruptcy.component';
import { EmploymentComponent } from './steps/employment/employment.component';
import { CashOutComponent } from './steps/cash-out/cash-out.component';
import { CashOutReasonComponent } from './steps/cash-out-reason/cash-out-reason.component';
import { CurrentFHAComponent } from './steps/current-fha/current-fha.component';
import { CreditRatingComponent } from './steps/credit-rating/credit-rating.component';
import { VeteranMilitaryComponent } from './steps/veteran-military/veteran-military.component';
import { CurrentVAComponent } from './steps/current-va/current-va.component';
import { BuyingProcessComponent } from './steps/buying-process/buying-process.component';
import { FirstTimeBuyerComponent } from './steps/first-time-buyer/first-time-buyer.component';
import { MaximumHomeEquityComponent } from './steps/maximum-home-equity/maximum-home-equity.component';
import { LoanPurposeComponent } from './steps/loan-purpose/loan-purpose.component';
import { PropertyStatusComponent } from './steps/property-status/property-status.component';
import { TimeFrameComponent } from './steps/time-frame/time-frame.component';
import { LeadReferrerService } from '../../../../services/lead-referrer.service';
import { OfficeStatus } from '../../../../shared/office-status';
import { JornayaService } from '../../../../services/jornaya.service';
import { BrandService } from '../../../../services/brand.service';
import { BestService } from '../../../../services/best.service';
import { AnalyticsService } from '../../../../services/analytics.service';
import { LoadScripts } from '../../../../services/load-scripts.service';
import { NeustarScore } from '../../../../shared/neustar-score';
import { CommunicationService } from '../../../../services/communication.service';
import { PropertyTypeConfirmationComponent } from './steps/property-type-confirmation/property-type-confirmation.component';
import { Title, Meta } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BankruptcyRecencyComponent } from './steps/bankruptcy-recency/bankruptcy-recency.component';
import { StepsService } from '../../../../services/steps.service';
import { HaveExistingMortgageComponent } from './steps/have-existing-mortgage/have-existing-mortgage.component';



@Component({
  selector: 'app-rates-form',
  templateUrl: './rates-form.component.html',
  styleUrls: ['./rates-form.component.scss'],
  animations: StepAnimations
})

export class RatesFormComponent implements OnInit {
  @ViewChildren(StepComponent) stepComponentList: QueryList<StepComponent>
  @HostListener('window:keyup', ['$event'])
  KeyEventsPlugin(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      // if (this.showPrompt) {
      //   this.continueWith('yes');
      //   return;
      // }

      if (typeof this.stepComponents[this.currentStepKey] !== 'undefined'
        && typeof this.stepComponents[this.currentStepKey].enterPress === 'function') {
        this.stepComponents[this.currentStepKey].enterPress();
      }
    }
  }
  @HostListener('window:blur', ['$event.target'])
  onBlur() {
    if (this.changeTabTitleIfTabLeaves) {
      this.timerId = window.setTimeout(() => {
        this.titleService.setTitle('Get Rates Now!');
      }, 5000);
    }
  }
  @HostListener('window:focus', ['$event.target'])
  onFocus() {
    if (this.changeTabTitleIfTabLeaves && this.timerId) {
      window.clearTimeout(this.timerId);
      this.timerId = null;
      this.titleService.setTitle(this.tabTitle);
    }
  }

  @HostBinding('class') themeName = this.getThemeName();

  officeStatus: OfficeStatus;
  neustarScore: NeustarScore;
  phoneScore: Number;
  stepComponents: Array<StepComponent>;
  form: UntypedFormGroup;
  type: string;
  formType: string;
  lp_button: string;
  objectKeys = Object.keys;
  state: string = 'inactive';
  currentStepKey: number = 0;
  stepHistory: Array<number> = [];
  debug: boolean;
  queryStringStep: string;
  currentDate: string = '';
  currentTime: string = '';
  removeBackgroundPhoneEmailStep: boolean = false;
  neustarTest: boolean = false;
  utm_campaign: string;
  utm_source: string;
  fruLocal: boolean = false;
  fruLocalKiosk: boolean = false;
  isTopTenBestLenders: boolean = false;
  showModal: boolean = false;
  leadDisclosure:boolean = false;
  protected experimentData: any;
  steps;
  tabTitle: string;
  changeTabTitleIfTabLeaves: boolean;
  timerId: number;
  currentYear: number = 2023;
  isSubmitting:boolean = false;
  siteLogo: boolean = false;
  userExiting: boolean = false;
  hasSeenPopup: boolean = false;
  mouseMoved: boolean = false;
  loanPurpose: string;
  recommendedLenderActive: boolean = false;
  removeTrackers: boolean = false;
  newDesignTop10FormABTest: boolean = false;

  // Selected Lead
  isSelectedLeads$: BehaviorSubject<boolean> = new BehaviorSubject(false); // We display it omle for searchmortgagerate.com for now
  isChecked: number = 1;
  availableSelected$: BehaviorSubject<SelectedResponse> = new BehaviorSubject({
    lead_id: 0,
    lenders: []
  });
  notSubmitedLeadId: number = 0;
  // showPrompt: boolean = false;
  // isContinueRedirect$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  // promptAllowed: boolean = false;
  // promptAsked: boolean = false;
  featuredLender: SelectedList;
  promptText: string = '';
  promptType: string = ''; // deselected all or featured?
  cancelSelectedRequest: boolean = false;

  defaultResponse: SelectedResponse = DefaultSelectedResponse;

  // isUncheckedTest$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  // isLendersCount$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isCashOutSet: boolean = false;
  cashOutAmount: number = 0;

  clientId: string;
  beState: string;
  isBeEnabled$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  isSecureForm: boolean = false;

  stateByIp: string;

  private exitIntentListener: () => void;
    regularStepLength: number = 0;

  private componentMappings: { [key: string]: any } = {
    // 'bankruptcy': BankruptcyComponent,
    // 'bankruptcy-recency': BankruptcyRecencyComponent,
    'buyingProcess': BuyingProcessComponent,
    'cashOut': CashOutComponent,
    'cashOutReason': CashOutReasonComponent,
    'creditRating': CreditRatingComponent,
    'currentFHA': CurrentFHAComponent,
    'currentVA': CurrentVAComponent,
    'email': EmailComponent,
    // 'lendersCount': LendersCountComponent,
    // 'selfEmployed': EmploymentComponent,
    'estimatedDownPayment': EstimatedDownPaymentComponent,
    'firstNameLastName': FirstNameLastNameComponent,
    'firstMortgageBalance': FirstMortgageBalanceComponent,
    'haveExistingMortgage': HaveExistingMortgageComponent,
    'firstTimeBuyer': FirstTimeBuyerComponent,
    'loanPurpose': LoanPurposeComponent,
    'maximumEquity': MaximumHomeEquityComponent,
    'neustar': NeustarComponent,
    'newHomeValue': NewHomeValueComponent,
    'phone': PhoneComponent,
    'propertyStatus': PropertyStatusComponent,
    'propertyType': PropertyTypeComponent,
    'propertyTypeConfirmation': PropertyTypeConfirmationComponent,
    'propertyValue': PropertyValueComponent,
    'propertyUse': PropertyUseComponent,
    'timeFrame': TimeFrameComponent,
    'veteranMilitary': VeteranMilitaryComponent,
    'zipCode': ZipCodeComponent,
    'zipCodeStreetAddress': ZipCodeStreetAddressComponent
  };

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private fruHttp: FruHttpService,
    private route: ActivatedRoute,
    private router: Router,
    private leadReferrerService: LeadReferrerService,
    private jornayaService: JornayaService,
    private communicationService:CommunicationService,
    public brandService: BrandService,
    public best: BestService,
    private deviceService: DeviceDetectorService,
    public analyticsService: AnalyticsService,
    private titleService: Title,
    private meta: Meta,
    private loadScripts: LoadScripts,
    private stepsService: StepsService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.stepHistory.push(0);
    this.tabTitle = this.titleService.getTitle();

    let d = new Date();
    this.currentYear = d.getFullYear();

    if(this.route.snapshot.queryParams['recommendedLender'] == 'true') {
			this.recommendedLenderActive = true;
		}

    // Exit intent listener
    var prevMouseYPosition = 100;
    let mouselistener = this.renderer.listen("document", "mousemove", event => {
      this.mouseMoved = true;
    });

    if (this.deviceService.isDesktop()) {
      this.exitIntentListener = this.renderer.listen("document", "mouseout", event => {
        const shouldShowExitIntent = !this.hasSeenPopup && this.mouseMoved && event.clientY < 10 && prevMouseYPosition < 100;

        if (shouldShowExitIntent) {
          document.removeEventListener("mouseout", this.exitIntentListener);
          this.showExitIntentPopup();
          this.analyticsService.trackGoal(60);
        }

        prevMouseYPosition = event.clientY;
      });
    }

    // AB Test activations
    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        //if no segment is required we can just set a true value at the start of the test
        /** @ToDo implement hit_segment */
        let hit = { hit_segment: true };
        variationData.enabledExperiments.forEach((x) => {
          Object.assign(x, hit);
        });
        this.experimentData = { enabledExperiments: variationData.enabledExperiments };
        if (variationData.enabledVariations.hasOwnProperty('RemoveBackgroundPhoneEmailStep')) {
          this.removeBackgroundPhoneEmailStep = true;
        }
        if (variationData.enabledVariations.hasOwnProperty('SiteLogo')) {
          this.siteLogo = true;
        }
        if (variationData.enabledVariations.hasOwnProperty('NeustarLoadingState')) {
          this.neustarTest = true;
        }

        //FRU-13214-a-b-test-change-tab-title-if-tab-leaves-focus
        this.changeTabTitleIfTabLeaves = variationData.enabledVariations.hasOwnProperty('ChangeTabTitleIfTabLeaves');

        // if (variationData.enabledVariations.hasOwnProperty('selectedJan27')) {
        //   if ((this.brandService.domain.includes('homeequitychoice')
        //     || this.brandService.domain.includes('freerateupdate')
        //     || this.brandService.domain.includes('besthomeequityloan'))
        //     && this.brandService.view != 'best'
        //   ) {
        //     this.isSelectedLeads$.next(true);
        //     this.isChecked = 1;
        //   }
        // }

        // if (variationData.enabledVariations.hasOwnProperty('selectedTop10Jan27')) {
        //   if (this.brandService.domain.includes('top10bestlenders')) {
        //     this.isSelectedLeads$.next(true);
        //     this.isChecked = 1;
        //   }
        // }

        // if (variationData.enabledVariations.hasOwnProperty('uncheckedReq')) {
        //   this.isUncheckedTest$.next(true);
        //   this.isChecked = 0;
        // }

        // if (variationData.enabledVariations.hasOwnProperty('lendersCount3')) {
        //   if (this.brandService.domain.includes('homeequitychoice')
        //     || this.brandService.domain.includes('freerateupdate')
        //     || this.brandService.domain.includes('besthomeequityloan')) {
        //     this.isLendersCount$.next(true);
        //   }
        // }

        if (variationData.enabledVariations.hasOwnProperty('FRU18292')) {
          if (this.brandService.domain.includes('top10bestlenders')
            || this.brandService.domain.includes('mortgagehomeequity')
          ) {
            this.newDesignTop10FormABTest = true;
          }
        }

        if (variationData.enabledVariations.hasOwnProperty('secureForm')) {
          if (this.brandService.domain.includes('top10bestlenders')
            || this.brandService.domain.includes('mortgagehomeequity')
          ) {
            this.isSecureForm = true;
          }
        }
      }
    );

    //get array of steps
    this.initializeSteps();
    //catch event from phone component
    this.communicationService.modalClosed.subscribe(
      (status: boolean) => {
        if (status) { this.toggleModal(); }
      });
  }

  // Add favicon links to header for given path
  private addFaviconLinks(faviconPath: string): void {
    const links = [
      { rel: 'shortcut icon', type: 'image/ico', href: `${faviconPath}favicon.ico` },
      { rel: 'apple-touch-icon', sizes: '180x180', href: `${faviconPath}apple-touch-icon.png` },
      { rel: 'icon', type: 'image/png', sizes: '32x32', href: `${faviconPath}favicon-32x32.png` },
      { rel: 'icon', type: 'image/png', sizes: '16x16', href: `${faviconPath}favicon-16x16.png` },
      { rel: 'manifest', href: `${faviconPath}site.webmanifest` },
    ];

    links.forEach(({ rel, href, type, sizes }) => {
      const link: HTMLLinkElement = this.document.createElement('link');
      link.rel = rel;
      link.href = href;

      if (type) link.type = type;
      if (sizes) link.setAttribute('sizes', sizes);

      this.document.head.appendChild(link);
    });
  }

  ngOnInit() {
    this.removeTrackers = document.cookie.split(';').some(cookie => cookie.trim().startsWith('fruRemoveCookies'));
    
    // Add favicon links
    if (this.brandService.data.domain === 'homeequityoptions.com') {
      this.addFaviconLinks('/application/views/www/public/assets/img/homeequityoptions-favicon/');
    }
    if (this.brandService.data.domain === 'top10bestlenders.com') {
      this.addFaviconLinks('/application/views/www/public/assets/img/top10-favicon-files/');
    }
    if (this.brandService.data.domain === 'mortgagehomeequity.com') {
      this.addFaviconLinks('/application/views/www/public/assets/img/mortgagehomeequity-favicon/');
    }
    
    // Set lead_referrer cookie if the LP was skipped
    this.leadReferrerService.setReferrer();

    // Set meta description
    const prettyDomain = this.brandService.data.prettyDomain || 'FreerateUpdate';
    this.brandService.updateMetaDescription(this.meta);

    // Set title
    const title = this.loanPurpose === 'personalloan'
      ? `Debt Consolidation & Personal Loans | ${prettyDomain}`
      : `Mortgage Refinance & Purchase, Home Equity & Cash Out Loans | ${prettyDomain}`;
    this.titleService.setTitle(title);
    // Get query string
    this.route.queryParams.subscribe(params => {
      this.type = params.LoanPurpose || '';
      this.debug = typeof params.debug !== 'undefined';
      this.queryStringStep = params.step || null;
      this.formType = params.FormType || '';
      this.lp_button = params.lp_button || '';
      this.utm_campaign = params.utm_campaign || null;
      this.utm_source = params.utm_source || null;
      this.fruLocal = this.utm_source == 'FRULocal' ?? false;
      this.isTopTenBestLenders = this.brandService.isTop10;
      this.fruLocalKiosk = this.utm_campaign == 'FRULocalKiosk' ?? false;
      this.communicationService.fruLocal = this.fruLocal;
      this.communicationService.fruLocalKiosk = this.fruLocalKiosk;
      if (this.brandService.pageType === 'default' && params.type) {
        this.brandService.pageType = params.type;
      }

      this.clientId = params.l || null;
      this.beState = params.state || null;

      // Fix up old bad urls
      this.type = this.type.toLowerCase();
      this.formType = this.formType.toLowerCase();
      // If no type, redirect to landing page
      // or no more steps and someone pushed go back in browser
      if(typeof this.steps === 'undefined' || this.currentStepKey >= this.steps.length) {
        return this.router.navigate(['/form-landing'], { queryParamsHandling: 'preserve' });
      }
      // If step key not exists (sometime it happen in mobile Safari/Chrome on iPhone)
      if (typeof this.steps[this.currentStepKey] === 'undefined'
        || typeof this.steps[this.currentStepKey].key === 'undefined') {
        let nextStep = this.currentStepKey - 1;
        if (nextStep >= 0) {
          this.nextStep(nextStep);
        }
      }

      this.cashOutAmount = params.cashout || 0;
      if (this.cashOutAmount > 0) {
        this.isCashOutSet = true;
      }

      this.communicationService.maxCashoutForm = params.maxCashoutForm === "yes";

      this.regularStepLength = this.steps.length - 3; //(this.lp_button == 'personalloan' ? 2 : 3);
      // If we've already started and what's in the query string doesn't match, this is a back button press
      if (this.steps && this.queryStringStep !== this.steps[this.currentStepKey].key
        && this.currentStepKey > 0) {
        this.stepHistory.pop(); //drop current step from history
        let nextStepKey = this.stepHistory.pop(); //pull previous step from history and set to next step
        this.nextStep(nextStepKey);
      }
    });

    // If no type, redirect to landing page
    if (typeof this.steps === 'undefined') {
      this.router.navigate(['/form-landing'], { queryParamsHandling: 'preserve' });
    }

    // Load Tests for Angular page
    if (!this.removeTrackers) {
      this.loadScripts.loadScript('/js/mm_include_tests.js?v=0.0.1');
    }

    // Init form
    // Alter form version for current experiment
    this.form = new UntypedFormGroup({});
    this.form.addControl('type', new UntypedFormControl(this.type));
    this.form.addControl('desiredLoanAmount', new UntypedFormControl(0));
    this.form.addControl('ltv', new UntypedFormControl(0));
    this.form.addControl('trustedFormUrl', new UntypedFormControl(''));
    this.form.addControl('experiment', new UntypedFormControl(''));
    this.form.addControl('experimentVariation', new UntypedFormControl(''));
    this.form.addControl('experimentData', new UntypedFormControl(''));
    this.form.addControl('jornayaLeadId', new UntypedFormControl(''));
    this.form.addControl('leadReferrer', new UntypedFormControl(this.leadReferrerService.leadReferrer));
    this.form.addControl('leadReferrerString', new UntypedFormControl(this.leadReferrerService.leadReferrerString));
    this.form.addControl('propertyState', new UntypedFormControl(''));
    this.form.addControl('propertyCity', new UntypedFormControl(''));
    this.form.addControl('pageType', new UntypedFormControl('v4-' + this.brandService.pageType));
    if (this.type === 'purchase') {
      this.form.addControl('daysFromBuying', new UntypedFormControl('no'));
      this.form.addControl('foundHome', new UntypedFormControl('no'));
      this.form.addControl('signedAgreement', new UntypedFormControl('no'));
    }
    this.form.addControl('formVersion', new UntypedFormControl('4'));
    this.form.addControl('rateType', new UntypedFormControl('30-Yr Fixed'));

    this.form.addControl('clientId', new UntypedFormControl(''));
    this.best.lenderSubscribe.subscribe((clientId) => {
      this.form.controls.clientId.setValue(clientId);
    });

    this.form.addControl('position', new UntypedFormControl(''));
    this.best.clientPosition.subscribe((position) => {
      this.form.controls.position.setValue(position);
    });

    this.form.addControl('fruSource', new UntypedFormControl(''));
    this.best.clientFruSource.subscribe((fruSource) => {
      this.form.controls.fruSource.setValue(fruSource);
    })

    this.form.addControl('formType', new UntypedFormControl(this.formType));
    this.form.addControl('lp_button', new UntypedFormControl(this.lp_button));

    // if (this.isSelectedLeads$.getValue()) {
    this.isSelectedLeads$.subscribe(value => {
      if (value) {
        this.form.addControl('nsLeadId', new UntypedFormControl(''));
        this.form.addControl('lenders', new FormArray([]));
        this.form.addControl('lendersList', new FormArray([]));
        this.form.addControl('selected_tcpa', new UntypedFormControl('1'));
        this.form.addControl('selectedListSource', new UntypedFormControl('selected_manager'));
      }
    });

    this.form.addControl('preCashOut', new UntypedFormControl(this.cashOutAmount));

    // Save visitor actions. Is all default
    if (this.type === 'purchase') {
      this.form.addControl('newHomeValueAction', new UntypedFormControl('0'));
      this.form.addControl('estimatedDownPaymentAction', new UntypedFormControl('0'));
    } else if (this.type === 'refinance' && this.lp_button != 'personalloan') {
      this.form.addControl('cashOutAction', new UntypedFormControl('0'));
      this.form.addControl('propertyValueAction', new UntypedFormControl('0'));
      this.form.addControl('firstMortgageBalanceAction', new UntypedFormControl('0'));
    }

    this.communicationService.getShouldSetDefaultSelected().subscribe(
      (enable: boolean) => {
        if(enable && !this.notSubmitedLeadId) {
          this.setDefaultSelectedResponse('default_angular_no_response');
        }
      });

    let d = new Date();
    let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const nth = function(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:  return 'st';
        case 2:  return 'nd';
        case 3:  return 'rd';
        default: return 'th';
      }
    }
    const formatAMPM = function(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    // ex: June 15th at 7:26 pm
    this.currentDate = monthNames[d.getMonth()] +' '+ d.getDate() + nth(d.getDate());
    this.currentTime = formatAMPM(d);
    // IE accept 'default' only from EDGE versios
    //this.currentDate = d.toLocaleString('default', { month: 'numeric', day: 'numeric', year: 'numeric' });
    //this.currentTime = d.toLocaleString('default', { hour: 'numeric', minute: 'numeric' });

    // console.log(this.beState);
    if (this.brandService.view == 'best' && this.beState != '' && this.clientId == '22783') {
      // deepcode ignore Ssrf: this method is run from the browser, not the server
      this.fruHttp.getBEstatus(this.clientId, this.beState, this.type).subscribe(response => {
        if (response.status == 'success') {
          this.isBeEnabled$.next(response.enabled);
          if (response.enabled == false) {
            this.brandService.logoSrc = '/assets/images/logo.png';
            this.router.navigate(['/rates-form'], { queryParams: {l: 'fru'}, queryParamsHandling: 'merge' });
          }
        }
      });
    }

  }

  ngAfterViewInit() {
    // For accessing the components themselves from here
    this.stepComponents = this.stepComponentList.toArray();
    // Get the office status
    let adnetwork = this.leadReferrerService.getAdnetwork();
    this.fruHttp.getOfficeStatus(this.type == 'personalloan' ? 'DebtConsolidation' : adnetwork).subscribe(officeStatus => this.officeStatus = officeStatus);
  }

  nextStep(stepKey?: number): void {
    // Jornaya snapshot
    this.jornayaService.snap();

    // if (this.steps[this.currentStepKey].key == 'phone' && this.promptAllowed && !this.promptAsked) {
    //   // Check is featured selected
    //   let isFeaturedDeSelected = false;
    //   let isFeatured = false;
    //   let checkedList = [];
    //   this.form.value.lendersList.forEach(value => {
    //     if (value.featured && !value.checked) {
    //       isFeaturedDeSelected = true;
    //       this.featuredLender = value;
    //     }
    //     if (value.checked) {
    //       checkedList.push(value.id);
    //     }
    //     if (value.featured) {
    //       isFeatured = true;
    //       this.featuredLender = value;
    //     }
    //   });

    //   let isAllDeSelected = false;
    //   if (this.form.value.lendersList.length > 0 && checkedList.length == 0) {
    //     isAllDeSelected = true
    //   }

    //   if (isAllDeSelected || isFeatured) {
    //     if (isAllDeSelected) {
    //       this.promptType = 'all_deselected';
    //       this.promptText = 'Do you want to Get Rates from Rocket Mortgage?';
    //     } else {
    //       if (isFeaturedDeSelected) {
    //         this.promptType = 'featured_deselected';
    //         this.promptText = 'Do you also want to Get Rates from ' + this.featuredLender.bank_name + '?';
    //       } else {
    //         this.promptType = 'featured_selected';
    //         this.promptText = 'Are you sure you want to Get Rates from ' + this.featuredLender.bank_name + '?';
    //       }
    //     }
    //     this.showPrompt = true;
    //     this.isContinueRedirect$.next(false);
    //     this.promptAsked = true;
    //     window['_paq'].push(['trackGoal', 75]); // Track goal about display prompt

    //   }
    // }

    // Disappear current step
    this.steps[this.currentStepKey].state = 'inactive';

    if (this.steps[this.currentStepKey].key == 'firstNameLastName' && this.isSelectedLeads$.getValue()) {
      // Send request to create "Not Submitted" lead and get lenders
      let postLead = new PostLead(this.form.value);
      if (this.notSubmitedLeadId === 0) {
        this.fruHttp.saveNotSubmitedLead(postLead, this.isChecked).subscribe(response => {
          if (!this.cancelSelectedRequest) {
            this.availableSelected$.next(response);
            this.notSubmitedLeadId = response.lead_id;
            this.form.controls.nsLeadId.setValue(response.lead_id);
            const lenderArray: FormArray = this.form.get('lenders') as FormArray;
            const lenderList: FormArray = this.form.get('lendersList') as FormArray;
            if (response.lenders) {
              response.lenders.forEach(value => {
                if (value.checked) {
                  lenderArray.push(new UntypedFormControl(value?.id));
                }
                lenderList.push(new UntypedFormControl(value));
              });
            }
          }
        });

        this.fruHttp.getDefaultLenders(postLead, this.isChecked).subscribe(response => {
          this.defaultResponse = response;
        });
      } else {
        console.log('Not allow submit twice');
      }
    }

    if (this.steps[this.currentStepKey].key == 'firstNameLastName' && this.form.controls.propertyState.value == '') {
      this.fruHttp.getStateNew().subscribe(response => {
        this.stateByIp = response?.state ?? '';
        if (this.stateByIp != '') {
          this.form.controls.propertyState.setValue(this.stateByIp);
        }
      });
    }

    if (this.steps[this.currentStepKey].key == 'email') {
      let postLead = new PostLead(this.form.value);
      if (this.notSubmitedLeadId) {
        this.fruHttp.updateNotSubmitedLead(postLead).subscribe(response => {
          console.log('Success');
        });
        let lenders = this.availableSelected$.getValue();
        if (lenders.lenders.length == 0) {
          this.setDefaultSelectedResponse('default_angular_empty_response', lenders.lead_id);
        }
      } else if (this.form.contains('selectedListSource')) {
        // We submit email step but still have no response from selected_manager
        //this.setDefaultSelectedResponse('default_angular_no_response');
      }
      postLead.abandonment = true;
      this.fruHttp.submitLead(postLead).subscribe();
    }

    this.neustarTest = false;
    // Check if phone step
    // step key comes through as undefined pretty often, this way of checking works for undefined/null and numbers greater
    // than the current step key incase that is ever passed to next step
    if(this.steps[this.currentStepKey].key == 'phone' && this.neustarTest && !(stepKey < this.currentStepKey)) {
      // console.log('started neustar test');
      // // Set experimentData
      // this.form.controls.experimentData.setValue(this.experimentData);
      // // Get trusted form url
      // let trustedForm = this.elementRef.nativeElement.querySelector('[name=xxTrustedFormCertUrl]');
      // this.form.controls.trustedFormUrl.setValue((trustedForm !== null) ? trustedForm.value : null);

      // // Get jornaya leadid
      // let leadId = this.elementRef.nativeElement.querySelector('[name=universal_leadid]');
      // this.form.controls.jornayaLeadId.setValue((leadId !== null) ? leadId.value : null);

      // // PostLead will convert to what lead_manager is expecting from all forms
      // let postLead = new PostLead(this.form.value);

      // // Get Score
      // if(this.isSubmitting == false) { // stop spam submits
      //   this.isSubmitting = true;
      //   console.log('is submitting');
      //   this.fruHttp.submitLead(postLead).subscribe(response => {
      //     console.log('submitlead response: ');
      //     console.log(response);

      //     this.phoneScore = Number(response.phone_score);
      //     if(Number(response.reverify_phone) == 1) {
      //       // only re-enable submits if they move to the next step
      //       this.isSubmitting = false;
      //       console.log('phone score was under 21');
      //       // Find next step
      //       this.currentStepKey = typeof stepKey !== 'undefined' ? stepKey : this.currentStepKey + 1;

      //       // See if we have a next step to show
      //       if (typeof this.steps[this.currentStepKey] !== 'undefined') {
      //         // Check if next step has a requirement
      //         if (typeof this.steps[this.currentStepKey].require === 'function' && !this.steps[this.currentStepKey].require()) {
      //           this.nextStep();
      //           return;
      //         }

      //         // Run any functions that need to happen before displaying
      //         if (typeof this.steps[this.currentStepKey].beforeDisplay === 'function') {
      //           this.steps[this.currentStepKey].beforeDisplay();
      //         }
      //         //save history
      //         this.stepHistory.push(this.currentStepKey);
      //         // Activate step
      //         this.steps[this.currentStepKey].state = 'active';

      //         this.analyticsService.trackQuestionShown(this.steps[this.currentStepKey].key);

      //         // Change url
      //         this.router.navigate(['/rates-form'], { queryParams: { step: this.steps[this.currentStepKey].key }, queryParamsHandling: 'merge' });

      //         // Run custom function initStep on step
      //         this.stepComponents[this.currentStepKey].initStep();
      //       }
      //     } else {
      //       console.log('phone score was above 21, doing full submit');
      //       this.handleSubmit(response);
      //     }
      //   });
      // }
    } else { // not phone step and/or not neustar test active
      // Find next step
      this.currentStepKey = typeof stepKey !== 'undefined' ? stepKey : this.currentStepKey + 1;

      // if (this.steps[this.currentStepKey]?.key == 'lendersCount' && !this.isLendersCount$.getValue()) {
      //   // Skip step, display it only for ab test
      //   this.nextStep();
      //   return;
      // }

      if (this.steps[this.currentStepKey]?.key == 'maximumEquity' && this.isCashOutSet) {
        this.nextStep();
        return;
      }

      // See if we have a next step to show
      if (typeof this.steps[this.currentStepKey] !== 'undefined') {
        //show text of disclosure on phone step if fruLocalKiosk
        this.leadDisclosure = (this.steps[this.currentStepKey].key == 'phone' && this.fruLocalKiosk) ?? false;
        // Check if next step has a requirement

        if (typeof this.steps[this.currentStepKey].require === 'function' && !this.steps[this.currentStepKey].require()) {
          this.nextStep();
          return;
        }

        // Run any functions that need to happen before displaying
        if (typeof this.steps[this.currentStepKey].beforeDisplay === 'function') {
          this.steps[this.currentStepKey].beforeDisplay();
        }
        //save history
        this.stepHistory.push(this.currentStepKey);
        // Activate step
        this.steps[this.currentStepKey].state = 'active';

        this.analyticsService.trackQuestionShown(this.steps[this.currentStepKey].key);


        // Change url
        this.router.navigate(['/rates-form'], { queryParams: { step: this.steps[this.currentStepKey].key }, queryParamsHandling: 'merge' });
        // Run custom function initStep on step
        this.stepComponents[this.currentStepKey].initStep();

      } else { // no next step to show

        // Set experimentData
        this.form.controls.experimentData.setValue(this.experimentData);
        // Get trusted form url
        let trustedForm = this.elementRef.nativeElement.querySelector('[name=xxTrustedFormCertUrl]');
        this.form.controls.trustedFormUrl.setValue((trustedForm !== null) ? trustedForm.value : null);

        // Get jornaya leadid
        let leadId = this.elementRef.nativeElement.querySelector('[name=universal_leadid]');
        this.form.controls.jornayaLeadId.setValue((leadId !== null) ? leadId.value : null);
        // PostLead will convert to what lead_manager is expecting from all forms
        let postLead = new PostLead(this.form.value);

        // Submit form
        this.isSubmitting = true;
        
        if (window['siteId'] == 1) {
          window['_paq'].push(['trackGoal', 69]);
        }

        this.fruHttp.submitLead(postLead)
          .subscribe(response => {
            this.handleSubmit(response);
          });
      }
    }
  }

  // continueWith(answer = 'no') {
  //   this.promptAsked = true;
  //   this.showPrompt = false;

  //   if (window['siteId'] == 1) {
  //     if (answer == 'no') {
  //       window['_paq'].push(['trackGoal', 74]);
  //     } else {
  //       window['_paq'].push(['trackGoal', 73]);
  //     }
  //   }

  //   // if (answer == 'no') {
  //   //   this.isContinueRedirect$.next(true);
  //   // } else {
  //     if (this.promptType == 'featured_deselected') {
  //       this.fruHttp.setRocketPromptAnswer(this.featuredLender.id, this.form.get('nsLeadId').value, this.promptType, answer).subscribe(response => {
  //         this.isContinueRedirect$.next(true);
  //       });
  //     } else if (this.promptType == 'featured_selected') {
  //       this.fruHttp.setRocketPromptAnswer(this.featuredLender.id, this.form.get('nsLeadId').value, this.promptType, answer).subscribe(response => {
  //         this.isContinueRedirect$.next(true);
  //       });
  //     } else {
  //       this.fruHttp.setAllPromptAnswer(this.form.value.lendersList, this.form.get('nsLeadId').value, this.promptType, answer).subscribe(response => {
  //         this.isContinueRedirect$.next(true);
  //       });
  //     }
  //   // }
  // }

  handleSubmit(response: FormResponse) {
    let cashOut = 0;
    let desiredLoanAmount = this.form.value.desiredLoanAmount ?? 0;
    if (this.form.value.cashOut && this.form.controls.maximumEquity) {
      cashOut = this.form.controls.maximumEquity.value == 'yes' && this.form.value.cashOut < 1000
        ? this.form.value.propertyValue * 0.9 - this.form.value.firstMortgageBalance
        : this.form.value.cashOut;
    }

    // this.isContinueRedirect$.subscribe(value => {
    //   if (value) {
        const lead: Lead = {
          type: this.type,
          propertyState: this.form.controls.propertyState.value,
          cashOut: cashOut,
          desiredLoanAmount: desiredLoanAmount,
          creditRating: this.form.controls.creditRating.value,
        };

        if (!response.status) {
          this.fruHttp.redirectOffers(lead);
          return;
        }

        switch (response.status) {
          case 'New':
          case 'Sent':
          case 'Block':
          case 'Review':
          case 'Not Sendable':
            // Go to thank you page
            let qr = this.fruLocalKiosk;
            this.fruHttp.redirectThankYou(lead, response, qr);
            break;

          default:
            // Go to offers page
            this.fruHttp.redirectOffers(lead);
            break;
        }
      // }
    // })

    // const lead: Lead = {
    //   type: this.type,
    //   propertyState: this.form.controls.propertyState.value,
    //   cashOut: cashOut,
    //   desiredLoanAmount: desiredLoanAmount,
    //   creditRating: this.form.controls.creditRating.value,
    // };

    // if (!response.status) {
    //   this.fruHttp.redirectOffers(lead);
    //   return;
    // }

    // switch (response.status) {
    //   case 'New':
    //   case 'Sent':
    //   case 'Block':
    //   case 'Review':
    //   case 'Not Sendable':
    //     // Go to thank you page
    //     let qr = this.fruLocalKiosk;
    //     this.fruHttp.redirectThankYou(lead, response, qr);
    //     break;

    //   default:
    //     // Go to offers page
    //     this.fruHttp.redirectOffers(lead);
    //     break;
    // }
  }

  setBackgroundImage() {
    if (!this.removeBackgroundPhoneEmailStep && !this.fruLocal) {
      // Add lender rates background image
      let ratesForm = this.elementRef.nativeElement.querySelector('#rates-form form');
      this.renderer.addClass(ratesForm, 'lender-rates-background');
      
      //show secure form and go back button
      let secureForm = this.elementRef.nativeElement.querySelector(".secure_form");
      this.renderer.addClass(secureForm, 'over_background');
      if (this.currentStepKey > 0) {
        let goBackArrow = this.elementRef.nativeElement.querySelector(".go-back-arrow");
        this.renderer.addClass(goBackArrow, 'over_background');
      }
      // Lighten modal background color
      let modal = this.elementRef.nativeElement.querySelector('#form-modal');
      this.renderer.addClass(modal, 'is-active');
    }
  }

  adDisclosurePopup() {
    this.fruHttp.adDisclosurePopup();
  }

  licensingDisclosurePopup() {
    this.fruHttp.licensingDisclosurePopup();
  }


  // Just in case we want this later, this is a thing
  stepAnimationDone() {
    var ratesform = document.getElementById('rates-form');
    if(ratesform && !this.fruLocal) {
      ratesform.scrollIntoView(); 
    }
  }
  
  goBack(): void {
    if (!this.currentStepKey || this.stepHistory.length < 2) {
      return;
    }

    this.stepHistory.pop(); //drop current step from history
    let nextStepKey = this.stepHistory.pop(); //pull previous step from history and set to next step
    let prevStep = this.steps[nextStepKey];

    // cashOut auto redirect to cashOutReason, so go 2 steps back
    if (prevStep?.key == 'cashOut' && this.steps[this.currentStepKey]?.key ==='cashOutReason') {
      this.form.controls.maximumEquity.setValue(null);
      nextStepKey = this.stepHistory.pop();
    } else if (prevStep?.key == 'cashOut' && this.steps[this.currentStepKey]?.key ==='propertyValue') {
      // For rm max home equity test we may need to go back 2 steps from here as well
      nextStepKey = this.stepHistory.pop();
    }

    if (this.communicationService.maxCashoutForm
      && this.steps[nextStepKey].key === 'maximumEquity'
      && this.steps[this.currentStepKey].key === 'cashOutReason') {
      nextStepKey = this.stepHistory.pop();
    }

    //this.analyticsService.trackGoal(23); /** @ToDo create new goal if reruning test */
    this.nextStep(nextStepKey);
  }

  toggleModal(): void {
    this.showModal = !this.showModal;
  }

  redirectToStartOver() {
    window.location.href = '/communication/form-landing/local' + window.location.search;
  }

  propertyTypeConfirmation() {
    return this.form.controls.propertyType.value === 'Mobile';
  }

  maximumEquity() {
    return this.form.value.maximumEquity !== 'yes';
  }

  cashOutReason() {
    return (this.form.controls.cashOut.value > 0 || this.form.value.maximumEquity === "yes")
      && (this.formType != "homeimprovement");
  }

  currentVA() {
    return this.form.controls.veteranMilitary.value === 'yes';
  }

  neustar() {
    return this.neustarTest;
  }

  bankruptcyRecency() {
    return this.form.controls.bankruptcy.value !== 'no';
  }

  propertyStatus() {
    return this.form.controls.formType.value != 'debtsettlement' && this.form.controls.formType.value != 'debtrelief';
  }

  housingSituationIsOwn() {
    return this.form.controls.housingSituation.value === 'Own';
  }

  initializeSteps() {
    const loanPurposeRaw = this.route.snapshot.queryParams['LoanPurpose'] || this.route.snapshot.queryParams['loanpurpose'] || '';
    this.loanPurpose = typeof loanPurposeRaw === 'object' ? loanPurposeRaw[0].toLowerCase() : loanPurposeRaw.toLowerCase();
    if (['refinance', 'purchase', 'personalloan'].indexOf(this.loanPurpose) < 0) return;

    const lpButton = this.route.snapshot.queryParams['lp_button'] || this.route.snapshot.queryParams['lp_button'] || '';
    const lp_button = typeof lpButton === 'object' ? lpButton[0].toLowerCase() : lpButton.toLowerCase();
    let loanPurpose = this.loanPurpose;

    if (lp_button == 'personalloan') {
      loanPurpose = 'pl';
    }

    this.steps = this.stepsService.getSteps(loanPurpose).map(step => {
      // Resolve component classes from strings
      if (this.componentMappings[step.key]) {
        step.component = this.componentMappings[step.key];
      }
      // Bind methods if specified
      if (step.beforeDisplay && typeof this[step.beforeDisplay] === 'function') {
        step.beforeDisplay = this[step.beforeDisplay].bind(this);
      }
      if (step.require && typeof this[step.require] === 'function') {
        step.require = this[step.require].bind(this);
      }

      return step;
    });

    this.steps[0]['state'] = 'active';
  }

  showExitIntentPopup () {
    this.userExiting = true;
    this.hasSeenPopup = true;
  }

  closeExitIntentPopup () {
    this.analyticsService.trackGoal(19);
    this.userExiting = false;
  }

  getThemeName(): string {
    switch (this.brandService.data.domain) {
      case 'pathtohome.com':
      case 'pathtohomebuying.com':
        return 'p2h-theme';

      case 'searchmortgagerate.com':
        return 'smr-theme';
        
      default:
        return '';
    }
  }

  phoneClicked() {
    window['_paq'].push(['trackGoal', 94]);
  }

  phoneClicked2() {
    window['_paq'].push(['trackGoal', 92]);
  }

  setDefaultSelectedResponse(listSource, nsLeadId = 0) {
    if(this.cancelSelectedRequest || !this.form.contains('selectedListSource')) {
      return;
    }

    this.cancelSelectedRequest = true;

    let response = this.defaultResponse;

    this.availableSelected$.next(response);
    this.notSubmitedLeadId = response.lead_id;
    this.form.controls.selectedListSource.setValue(listSource);
    this.form.controls.nsLeadId.setValue(nsLeadId ? nsLeadId : response.lead_id);
    const lenderArray: FormArray = this.form.get('lenders') as FormArray;
    const lenderList: FormArray = this.form.get('lendersList') as FormArray;
    response.lenders.forEach(value => {
      if (value.checked) {
        lenderArray.push(new UntypedFormControl(value?.id));
      }
      lenderList.push(new UntypedFormControl(value));
    });
  }
}
